<template>
  <el-carousel trigger="click" height="80px" direction="vertical" autoplay loop>
    <el-carousel-item v-for="item in 3" :key="item">
      <h3 class="small">{{ item }}</h3>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
  export default {
    name: "Advertising"
  }
</script>

<style scoped>

</style>
